import { createLucideIcon } from 'lucide-react';

// The glyph is a knockout in the disc, so it shows the surface behind the icon. A
// white disc below the coloured one fills the knockout with a fixed white. Its
// radius is 1 less, so no pale edge shows around the rim.

export const ClockSolid = createLucideIcon('ClockSolid', [
  [
    'circle',
    {
      cx: '12',
      cy: '12',
      r: '10',
      fill: '#fff',
      stroke: 'none',
    },
  ],
  [
    'path',
    {
      d: 'M12 1a11 11 0 1 1 0 22 11 11 0 0 1 0-22m-.2 3.2q-1.2.1-1.3 1.3V12q.1.9.8 1l6.3 2.4a1.3 1.3 0 0 0 .9-2.4L13 11V5.5q-.1-1.2-1.2-1.3',
      fill: 'currentColor',
      fillRule: 'evenodd',
      stroke: 'none',
    },
  ],
]);
